import React from "react";
import { Segment, Divider, Pagination, Header, Icon, Button } from "semantic-ui-react";
import { AgGridReact } from "ag-grid-react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import { debounce, isEqual } from "lodash";
import { push } from "connected-react-router";
import { withRouter } from "react-router-dom";

import { CustomerUserGridColumns } from "../column";
import GridPageSizePicker from "../../common/components/grid-page-size-picker";
import { loadCustomerUserList } from "../actions/list";
import { changeCustomerUserGridState } from "../actions/grid";

class CustomerUserContainerGrid extends React.Component {
    grid = null;

    UNSAFE_componentWillMount() {
        // attempt to load only if no data has been loaded before and there isn't already an api call happening right now

        this.props.loadCustomerUserList({ customerId: this.props.match.params.customer_id });
    }

    componentDidUpdate(prevProps) {
        if (!this.grid) return;

        if (!isEqual(prevProps.hiddenColumns, this.props.hiddenColumns)) {
            this.syncColumns();
        }

        if (!this.props.isLoading) {
            this.grid.api.hideOverlay();
            this.resizeGrid();
        }

        if (prevProps.currentPage !== this.props.currentPage) {
            this.grid.api.paginationGoToPage(this.props.currentPage);
        }

        if (this.props.isLoading) {
            this.grid.api.showLoadingOverlay();
        }
    }

    resizeGrid = debounce(() => {
        this.grid && this.grid.api.sizeColumnsToFit();
    }, 300);

    onGridReady = grid => {
        this.grid = grid;
        this.syncColumns();

        if (this.props.isLoading) {
            grid.api.showLoadingOverlay();
        }

        this.grid.columnApi.applyColumnState({ state: this.props.sortModel, defaultState: {} });
        this.grid.api.setFilterModel(this.props.filterModel);
        this.grid.api.paginationGoToPage(this.props.currentPage);

        this.grid.api.addEventListener("sortChanged", () => {
            const colStates = this.grid.columnApi.getColumnState();
            const sortModel = colStates
                .filter(colState => colState.sort)
                .map(colState => ({
                    colId: colState.colId,
                    sort: colState.sort,
                }));

            this.props.changeCustomerUserGridState({
                sortModel,
            });
        });

        this.grid.api.addEventListener("filterChanged", () => {
            this.props.changeCustomerUserGridState({
                filterModel: this.grid.api.getFilterModel(),
            });
        });
        this.grid.api.addEventListener("rowClicked", e => {
            if (!e.data || !e.data.id || !this.props.onRowSelect) return;

            this.props.onRowSelect(e.data);
        });
    };

    syncColumns = () => {
        if (this.props.hiddenColumns)
            this.grid.columnApi.setColumnsVisible(this.props.hiddenColumns, false);

        if (this.props.shownColumns)
            this.grid.columnApi.setColumnsVisible(this.props.shownColumns, true);

        setTimeout(() => this.grid && this.grid.api.sizeColumnsToFit(), 300);
    };

    render() {
        const {
            data,
            pageSize,
            isLoading,
            changeCustomerUserGridState,
            showInvitationalModal,
            setShowInvitationalModal,
        } = this.props;

        const invitePeople = () => {
            setShowInvitationalModal(!showInvitationalModal);
        };

        if (!isLoading && data.length < 1) {
            return (
                <Segment placeholder>
                    <Header icon>
                        <Icon name="newspaper outline" />
                        You have no registered user.
                    </Header>
                    <Button positive onClick={() => invitePeople()}>
                        Invite People
                    </Button>
                </Segment>
            );
        }

        return (
            <>
                <Segment className="customer-grid" vertical>
                    <div className="ag-theme-balham">
                        <AgGridReact
                            rowData={data}
                            rowHeight={40}
                            pagination={true}
                            paginationPageSize={this.props.pageSize}
                            domLayout="autoHeight"
                            suppressPaginationPanel={true}
                            onGridReady={this.onGridReady}
                            columnDefs={CustomerUserGridColumns}
                            defaultColDef={{
                                sortable: true,
                                floatingFilter: true,
                                resizable: true,
                                suppressMenu: true,
                            }}
                        />
                    </div>

                    <div className="tp-10 clearing">
                        <GridPageSizePicker
                            button
                            compact
                            pointing="top"
                            pageSize={pageSize}
                            text={`${pageSize}/page`}
                            className="left floated basic"
                            onChange={changeCustomerUserGridState}
                        />
                        <Pagination
                            size="mini"
                            floated="right"
                            defaultActivePage={1}
                            totalPages={Math.ceil(data.length / pageSize)}
                            onPageChange={(e, data) =>
                                changeCustomerUserGridState({ currentPage: data.activePage - 1 })
                            }
                        />
                        <Divider hidden fitted clearing />
                    </div>
                </Segment>
            </>
        );
    }
}

const mapStateToProps = ({ customerUserGrid, customerUserList }) => ({
    data: customerUserList.data,
    error: customerUserList.error,
    isLoading: customerUserList.isLoading,

    pageSize: customerUserGrid.pageSize,
    sortModel: customerUserGrid.sortModel,
    currentPage: customerUserGrid.currentPage,
    filterModel: customerUserGrid.filterModel,
});

const mapDispatchToProps = dispatch =>
    bindActionCreators(
        {
            push,
            loadCustomerUserList,
            changeCustomerUserGridState,
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(CustomerUserContainerGrid));
